// extracted by mini-css-extract-plugin
export var avatarContainer = "_9d-0";
export var avatarTypingWave = "_9d-i";
export var gray = "_9d-f";
export var green = "_9d-c";
export var icon = "_9d-9";
export var image = "_9d-1";
export var lg = "_9d-6";
export var md = "_9d-5";
export var presenceDot = "_9d-b";
export var red = "_9d-d";
export var sm = "_9d-4";
export var status = "_9d-a";
export var typingDot = "_9d-h";
export var typingPill = "_9d-g";
export var xl = "_9d-7";
export var xs = "_9d-3";
export var xxl = "_9d-8";
export var xxs = "_9d-2";
export var yellow = "_9d-e";